import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, of } from 'rxjs';
import { catchError, retry, takeUntil, tap } from 'rxjs/operators';

import { LoadingService } from '../../../../../../core/layout/services/loading.service';
import { NavController } from '@ionic/angular';
import { TaxesTariffService } from '@wlp/ui-bs-cashout';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';

@Component({
  selector: 'app-fees-tariffs',
  templateUrl: './fees-tariffs.page.html',
  styleUrls: ['./fees-tariffs.page.scss'],
})
export class FeesTariffsPage implements OnInit, OnDestroy {
  public userProfile: UserInfoProfile;
  public listData: any[];

  private destroy$: Subject<null> = new Subject();

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  constructor(
    private service: TaxesTariffService,
    private navCtrl: NavController,
    protected userInfoService: UserInfoService,
    private loadingService: LoadingService,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService
  ) { }

  public ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.loadUser();
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getListFeesTariffs() {
    this.loadingService.show();
    this.service
      .getTaxesTariff(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount)
      .pipe(
        takeUntil(this.destroy$),
        tap((data) => {
          this.listData = data;
          this.loadingService.hide();
        }),
        retry(2),
        catchError((_) => {
          this.loadingService.hide();
          return of(null);
        })
      )
      .subscribe();
  }

  private loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();

      userDetails
        .then((user) => {
          this.userProfile = user;
          this.getListFeesTariffs();
        })
        .catch((error) => {
          this.navCtrl.navigateRoot(`/app/dashboard`);
        });
    } catch (e) {
    }
  }
}
